'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _doTicksEqual = require('./doTicksEqual');

var _doTicksEqual2 = _interopRequireDefault(_doTicksEqual);

var _doArrayDifferJustOneEntry = require('./doArrayDifferJustOneEntry');

var _doArrayDifferJustOneEntry2 = _interopRequireDefault(_doArrayDifferJustOneEntry);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (ticks1, ticks2) {
    return (0, _doArrayDifferJustOneEntry2.default)(ticks1, ticks2, _doTicksEqual2.default);
};


//////////////////
// WEBPACK FOOTER
// ./~/binary-utils/lib/ticks/doTicksDifferJustOneEntry.js
// module id = 115
// module chunks = 0